import { FeatureConfiguration } from "features";
import { reducer } from "./reducers";
import { LocationRelations } from "./components/LocationRelations";

export default function (config: FeatureConfiguration) {
    config.reducers.locationRelations = reducer;

    config.addRoutes(config.routes.locationRoutes, [<LocationRelations key="location-relations" />]);
}
